export const quizQuestions = [
  {
    id: "question16",
    videoId: "video16",
    topic: "TSMR",
    question: "These are the main reasons of road rage except",
    options: [
      "Aggressive Lane Changes",
      "Verbal Altercation",
      "Defensive Driving",
    ],
    correctAnswer: "Defensive Driving",
    descriptionTitle: "BUS STOP Sign",
    description1:
      "A Bus Stop sign is a road traffic sign that indicates the location where buses are authorized to stop to pick up or drop off passengers. It serves as a designated point on the road where public transportation vehicles, such as buses, are expected to stop to allow passengers to board or disembark.",
  },
  {
    id: "question17",
    videoId: "video17",
    topic: "TSMR",
    question: "A driver must must not do the following acts:",
    options: ["Tailgate", "Drive Defensively", "Overtake"],
    correctAnswer: "Tailgate",
    descriptionTitle: "BUS STOP Sign",
    description1:
      "A Bus Stop sign is a road traffic sign that indicates the location where buses are authorized to stop to pick up or drop off passengers. It serves as a designated point on the road where public transportation vehicles, such as buses, are expected to stop to allow passengers to board or disembark.",
  },
  {
    id: "question18",
    videoId: "video18",
    topic: "TSMR",
    question: "Annoying Blowing of horn is one of the reasons why ___ happens:",
    options: ["Confrontation", "Road Rage", "Peace"],
    correctAnswer: "Road Rage",
    descriptionTitle: "BUS STOP Sign",
    description1:
      "A Bus Stop sign is a road traffic sign that indicates the location where buses are authorized to stop to pick up or drop off passengers. It serves as a designated point on the road where public transportation vehicles, such as buses, are expected to stop to allow passengers to board or disembark.",
  },
];
